<div class="innerPagesBlock">
  <app-side-menu></app-side-menu>
  <div class="innerPagesRight customScroll">

    <app-banner-footer-pages [title]="title1"></app-banner-footer-pages>
    <div class="innerpageContentBox mb-5">
      <div class="innerpageContent">
      <div class="row">
        <div class="col-lg-3">
          <div class="inputGroup">
            <mat-form-field class="w-100 mat-input-group" appearance="outline">
              <mat-label class="matLabel">Category </mat-label>
              <mat-select formControlName="productCategoryId">
                <mat-option *ngFor="let item of categories" [value]="item.id">{{item.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="inputGroup">
            <mat-form-field class="w-100 mat-input-group" appearance="outline">
              <mat-label class="matLabel">Product Type </mat-label>
              <mat-select formControlName="productTypeId">
                <mat-option *ngFor="let item of productType" [value]="item.id">{{item.name}}</mat-option>

              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="inputGroup">
            <mat-form-field class="w-100 mat-input-group" appearance="outline">
              <mat-label class="matLabel">Status </mat-label>
              <mat-select formControlName="validationStatusId">
                <mat-option *ngFor="let item of productStatus" [value]="item.id">{{item.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="inputGroup">
            <mat-form-field class="w-100 mat-input-group" appearance="outline">
              <mat-label class="matLabel">Reg Date </mat-label>
              <mat-select formControlName="publishedAt">
                <mat-option>test1</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="text-center">
        <div class="btnbx mt-5">
          <button type="button" class="btnThemeOutline blue me-3" (click)="reset()">Reset</button>
          <button class="btnTheme red" (click)="filter()">Search</button>
        </div>
      </div>
      </div>
      <div class="top-categeryHead">
        <div class="categeryHead-text">
          <h1 [innerHTML]="title"></h1>
        </div>
        <div class="btnGrpp">
        </div>
      </div>

      <div class="admin-table desktop">
        <div class="tableblock">
          <div class="serchsec">
            <div class="serchblk">
              <div class="searchInputbx">
                <input type="text" [value]="searchProduct" class="inputBox2" id="weburl" placeholder=""
                  (input)="searchProductOnChange($event)" />
                <div class="removeico" (click)="searchProductOnChange($event)"><img
                    src="assets/images/removeRoundgrey.svg" alt="Remove"></div>
              </div>
            </div>
          </div>
          <table class="adminPanel-table">
            <tr>
              <th>S.No</th>
              <th>Product Name</th>
              <th>Product Description</th>
              <th>Category</th>
              <th>Price</th>
              <th>quantity</th>
              <th>STATUS</th>
              <th>ACTIONS</th>
            </tr>
            <div class="text-center" *ngIf="this.loading">
              <div class="loader"></div>
            </div>
            <ng-container *ngIf="!loading && products.length; else showEmptyView">
              <tr *ngFor="
              let product of products index as i">
                <td>
                  <div class="serielNo">
                    {{ i + 1 + this.pageLimit * (this.currentPage - 1) }}</div>
                </td>
                <td>
                      {{ product.name }}
                </td>
                <td>
                  <div class="product-detailListCard">
                  <div class="prod-text max-500" *ngIf="!getProductShortDescription(product.description)"[innerHtml]="product.description"></div>
                  <div class="viewbbtn" *ngIf="getProductShortDescription(product.description)"
                    (click)="showProductDescription(product.description)">View Description</div>
                    </div>
                </td>
                <td>{{ product.categories }}</td>
                <td class="text-end">
                  <div class="prodlist-prises align-content-end">
                    <p class="prod-mrp  text-end">MRP</p>
                    <P class="prod-prise text-end">₹ {{ product.price }}</P>
                  </div>
                </td>
                <td>
                  <div class="prodListQty"> {{ product.quantity }}</div>
                </td>
            <td>
              <div class="prodListQty"> {{ product.status }}</div>
            </td>
                <td>
                  <div class="actions">
                    <!-- <button class="action" (click)="this.showProductDetails(product.productId)">
                      <img src="./assets/images/eye-line.svg" alt="" />
                    </button> -->
                    <button class="action" (click)="this.showEditProductCard = product.productId">
                      <img src="./assets/images/eye-line.svg" alt="" />
                    </button>
                    <button class="action" (click)="this.showUpdateProductCard = product.productId">
                      <img src="./assets/images/edit-icon.svg" alt="" />
                    </button>
                  </div>
                </td>
              </tr>
            </ng-container>
          </table>
        </div>
      </div>
      <div class="proListdataSec mob">
        <div class="text-center" *ngIf="this.loading">
          <div class="loader"></div>
        </div>
        <div class="proListdataBlock">
          <div class="product-card" *ngFor=" let product of products | paginate
            : {
                itemsPerPage: 10,
                currentPage: currentPage,
                totalItems: totalRecords
              };
              index as i
          ">
            <div class="proListdataRow">
              <div class="proListdataItem">
                <!-- <div class="serielNo">
                {{ i + 1 + this.pageLimit * (this.currentPage - 1) }}</div>
              <div class="prodList-logo"> -->
                <img src="./assets/images/logos_shopify.svg" alt="" class="sopyicon" />
              </div>
              <div class="proListdataItem">
                <div class="product-detailListCard">
                  <div class="productList-image">
                    <img src="./assets/images/prod-list.svg" alt="" />
                  </div>
                  <div class="productlist-detail">
                    <div class="prod-title">{{ product.name }}</div>
                    <div class="prod-text max-500" [innerHtml]="product.description"></div>
                    <button *ngIf="getProductShortDescription(product.description)"
                      (click)="showProductDescription(product.description)">View Description</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="proListdataRow">
              <div class="proListdataItem">{{ product.categories }}</div>
              <div class="proListdataItem">
                <div class="prodListQty"><strong>QTY</strong> <span class="qtn">{{ product.quantity }}</span></div>
              </div>
            </div>
            <div class="proListdataRow">
              <div class="proListdataItem">
                <div class="prodlist-prises align-items-end">
                  <p class="prod-mrp text-end">MRP</p>
                  <P class="prod-prise text-end">₹ {{ product.price }}</P>
                </div>
              </div>
            </div>
            <div class="proListdataRow">
              <div class="proListdataItem">
                <div class="actions">
                  <button class="action" (click)="this.showProductDetails(product.productId)">
                    <img src="./assets/images/eye-line.svg" alt="" />
                  </button>
                  <button class="action" (click)="this.showEditProductCard = product.productId">
                    <img src="./assets/images/edit-icon.svg" alt="" />
                  </button>
                  <button class="action" (click)="this.showUpdateProductCard = product.productId">
                    <img src="./assets/images/trash-icon.svg" alt="" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <!-- <div class="text-end my-4">
        <pagination-controls (pageChange)="getPage($event)"></pagination-controls>
      </div> -->

      <app-pagination *ngIf="!this.loading" class="mt-4 d-block" [currentPage]="currentPage" [totalItems]="totalRecords"
        [itemsPerPage]="pageLimit" (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"></app-pagination>
    </div>
  </div>
  <c-modal id="descripton-pop" [visible]="showDescription" backdrop="static" class="appModel productListmodel"
    alignment="center">
    <div class="modelContentBox py-3 px-4" *ngIf="showDescription">
      <div class="modelheader mb-8">
        <button cButtonClose class="modelClose" (click)="showDescription = false"></button>
      </div>
      <div class="modelBOdy">
        <div [innerHtml]="description"></div>
      </div>
    </div>
  </c-modal>

  <c-modal id="editProductDetails" [visible]="this.showUpdateProductCard !== 0" *ngIf="this.showUpdateProductCard !== 0" class="addpro" alignment="center" size="xl">
    <div class="modelContentBox py-3 px-4">
      <div class="modelheader mb-8">
        <button cButtonClose class="modelClose" (click)="this.handleUpdateProduct(0);"></button>
      </div>
      <div class="modelBOdy">
        <app-edit-product [formTitle]="title3" [selectedProductId]="this.showUpdateProductCard" [update]="'edit'" (resetListing)="this.resetEditListing()"></app-edit-product>
      </div>
    </div>
  </c-modal>
  <!-- add product popup start -->
  <c-modal id="addProductDetails" [visible]="this.showAddProductCard" *ngIf="this.showAddProductCard" class="addpro" alignment="center" size="xl">
    <div class="modelContentBox py-3 px-4">
      <div class="modelheader mb-8">
        <button cButtonClose class="modelClose" (click)="this.handleAddProduct(false);"></button>
      </div>
      <div class="modelBOdy">
        <app-add-product [formTitle]="title2" (resetListing)="this.resetListing()"></app-add-product>
      </div>
    </div>
  </c-modal>
  <!-- add product popup end -->


  <!-- edit product popup start -->
  <c-modal id="editProductDetails" [visible]="this.showEditProductCard !== 0" *ngIf="this.showEditProductCard !== 0" class="addpro" alignment="center" size="xl">
    <div class="modelContentBox py-3 px-4">
      <div class="modelheader mb-8">
        <button cButtonClose class="modelClose" (click)="this.handleEditProduct(0);"></button>
      </div>
      <div class="modelBOdy">
        <app-edit-product [formTitle]="title3" [selectedProductId]="this.showEditProductCard" [update]="'update'" (resetListing)="this.resetEditListing()"></app-edit-product>
      </div>
    </div>
  </c-modal>
  <!-- edit product popup end -->


  <!-- show product details popup start-->
  <c-modal id="productDetails" [visible]="this.showDetails" backdrop="static" class="addpro" alignment="center"
    size="xl">
    <div class="modelContentBox py-3 px-4">
      <div class="modelheader mb-8">
        <button cButtonClose class="modelClose" (click)="this.showDetails = false"></button>
      </div>
      <div class="text-center" *ngIf="this.productDetails.loading">
        <div class="loader"></div>
      </div>

      <div class="themeAlert danger" *ngIf="this.productDetails.error">
        {{this.productDetails.error}}
      </div>
      <div class="modelBOdy" *ngIf="!this.productDetails.loading && !this.productDetails.error">
        <form [formGroup]="addProductForm" (ngSubmit)="createNewProduct()">
          <div class="frmbbxx">
            <!-- <div class="loader"></div> -->
            <app-main-heading [title]="productDetailsTitle"></app-main-heading>
            <div class="productPoup1">
              <div class="row">
                <div class="col-lg-4">
                  <div class="inputGroup">
                    <input type="text" class="inputBox" id="productName"
                      [value]="this.productDetails?.response?.productName || ''" readonly />
                    <label for="productName" class="inputLabel popInLabel">Product name</label>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="inputGroup">
                    <mat-form-field class="w-100 mat-input-group" appearance="outline">
                      <mat-label class="matLabel">Category </mat-label>
                      <input matInput [value]="this.productDetails.response?.categoryName || ''" readonly />
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="inputGroup">
                    <mat-form-field class="w-100 mat-input-group" appearance="outline">
                      <mat-label class="matLabel">Sub Category </mat-label>
                      <!-- <mat-select formControlName="productTypeId">
                        <mat-option>test1</mat-option>
                      </mat-select> -->
                      <input matInput [value]="this.productDetails.response?.subCategoryName || ''" readonly />

                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-8">
                  <div class="inputGroup">
                    <textarea placeholder="" class="inputBox regTextarea prodModelAreaheight addhtt" readonly
                      [value]="this.productDetails.response?.description || ''"></textarea>
                    <label for="addreg" class="inputLabel popInLabel">Write something...</label>
                  </div>
                  <!-- <span class="passError d-block text-start">Please write something </span> -->
                </div>
                <div class="col-lg-4">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="inputGroup">
                        <input type="text" class="inputBox" id="sofylink" readonly
                          [value]="this.productDetails.response?.shopifyLink || ''" placeholder="" />
                        <label for="sofylink" class="inputLabel popInLabel">Shopify Link</label>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="inputGroup">
                            <input [value]="this.productDetails.response?.weight || ''" class="inputBox" placeholder=""
                              readonly />
                            <label for="weight" class="inputLabel popInLabel">
                              Weight
                            </label>
                          </div>
                        </div>

                        <div class="col-lg-6">
                          <div class="inputGroup">
                            <mat-form-field class="w-100 mat-input-group" appearance="outline">
                              <mat-label class="matLabel">Weight Unit </mat-label>
                              <!-- <mat-select formControlName="productTypeId">
                                <mat-option>test1</mat-option>
                              </mat-select> -->
                              <input matInput [value]="this.productDetails.response?.weightUnit || ''" readonly />

                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="inputGroup">
                    <mat-form-field class="w-100 mat-input-group" appearance="outline">
                      <mat-label class="matLabel">Del. Distance </mat-label>
                      <input type="text" matInput readonly [value]="this.productDetails.response?.delDistance || ''">
                      <!-- <mat-select formControlName="delDistance">
                        <mat-option>test1</mat-option>
                      </mat-select> -->
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="inputGroup">
                    <mat-form-field class="w-100 mat-input-group" appearance="outline">
                      <mat-label class="matLabel">Product Type </mat-label>
                      <!-- <mat-select formControlName="productTypeId">
                        <mat-option>test1</mat-option>
                      </mat-select> -->
                      <input type="text" matInput readonly [value]="this.productDetails.response?.productType || ''">

                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="inputGroup">
                    <mat-form-field class="w-100 mat-input-group" appearance="outline">
                      <mat-label class="matLabel">Packing Type </mat-label>
                      <!-- <mat-select formControlName="packingTypeId">
                        <mat-option>test1</mat-option>
                      </mat-select> -->
                      <input type="text" matInput readonly [value]="this.productDetails.response?.packingType || ''">

                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="imgUploadTitle">Upload Product photo</div>
                  <div class="imageUploadSec" *ngIf="this.productDetails.response?.mediaList">
                    <div class="imageUpload me-2" *ngFor="let item of this.productDetails.response.mediaList">
                      <img src="{{item.src}}" class="width-64" alt="" />
                    </div>
                  </div>
                  <div class="imgUploadText">
                    *Recommended resolution is 640×640 with file size
                  </div>
                </div>
                <div class="tablebox" *ngIf="this.productDetails.response?.variantList.length">
                  <div class="addBlockpr customScroll">
                    <div class="addBlockprHead">
                      <div class="hedItm">S. No</div>
                      <div class="hedItm">SKU OR BARCODE or variant name</div>
                      <div class="hedItm">Quantity</div>
                      <div class="hedItm">Stock Status</div>
                      <div class="hedItm">Status</div>
                      <div class="hedItm">Attribute 1</div>
                      <div class="hedItm">Attribute 2</div>
                      <div class="hedItm">MRP</div>
                      <div class="hedItm">Discounted Price</div>
                      <div class="hedItm">Variant photo</div>
                    </div>
                    <div class="addrecRow" *ngFor="let item of this.productDetails.response.variantList; index as i;">
                      <div class="addrecItm">{{i+1}}</div>
                      <div class="addrecItm">
                        <div class="inputGroup w-100">
                          <input type="text" class="inputBox" id="sku" placeholder="" [value]="item.sku || ''"
                            readonly />
                          <label for="sku" class="inputLabel popInLabel">
                            SKU OR BARCODE
                          </label>
                        </div>
                      </div>
                      <div class="addrecItm">
                        <div class="inputGroup">
                          <input type="text" [value]="item.quantity || ''" readonly class="inputBox" id="qult"
                            placeholder="" />
                          <label for="qult" class="inputLabel popInLabel">Quantity</label>
                        </div>
                      </div>
                      <div class="addrecItm">
                        <div class="inputGroup">
                            <input type="text" matInput [value]="item.stockStatus || ''" readonly class="inputBox"
                              id="stksts" placeholder="" />
                            <label for="stksts" class="inputLabel popInLabel">Stock Status</label>
                        </div>
                      </div>
                      <div class="addrecItm">
                        <div class="inputGroup">
                            <input type="text" matInput [value]="item.status || ''" readonly class="inputBox" id="sts"
                              placeholder="" />
                              <label for="sts" class="inputLabel popInLabel">Status</label>
                        </div>
                      </div>
                      <div class="addrecItm">
                        <div class="inputGroup">
                            <input type="text" matInput [value]="item.variantOption1 || ''" readonly class="inputBox"
                              id="variant" placeholder="" />
                              <label for="variant" class="inputLabel popInLabel">Status</label>
                        </div>
                      </div>
                      <div class="addrecItm">
                        <div class="inputGroup">
                            <input type="text" matInput [value]="item.variantOption2 || ''" readonly class="inputBox"
                              id="attr" placeholder="" />
                              <label for="attr" class="inputLabel popInLabel">Status</label>
                        </div>
                      </div>
                      <div class="addrecItm">
                        <div class="inputGroup">
                          <input type="text" [value]="item.price || ''" class="inputBox" id="mrp" placeholder=""
                            readonly />
                          <label for="mrp" class="inputLabel popInLabel">MRP
                          </label>
                        </div>
                      </div>
                      <div class="addrecItm">
                        <div class="inputGroup">
                          <input type="text" [value]="item.discountedPrice || ''" class="inputBox" id="discounted"
                            placeholder="" style="width: 200px;" readonly />
                          <label for="discounted" class="inputLabel popInLabel">Discounted Price</label>
                        </div>
                      </div>
                      <div class="addrecItm">
                        <div class="imageUploadSec" *ngIf="item?.mediaList">
                          <div class="imageUpload me-2" *ngFor="let image of item.mediaList">
                            <img src="{{image.src}}" class="width-64" alt="" />
                          </div>
                        </div>
                      </div>
                      <!-- <td><button class="action">
                          <img src="./assets/images/trash-icon.svg" alt="" />
                        </button></td> -->
                    </div>
                  </div>
                </div>
                <!-- <div class="aabtn d-block text-start mt-4">
                  <button class="btnTextPluse">+ Add another option</button>
                </div> -->
              </div>
            </div>
            <!-- <div class="text-center d-block mb-2">
              <div class="btnbx modPopBtns mt-3">
                <button type="button" class="btnThemeOutline blue me-3 modelPopup-btn">
                  Reset
                </button>
                <button class="gredientOutLineBtn">
                  <div class="btnContent modelPopup-btn">Add New Product</div>
                </button>
              </div>
            </div> -->
          </div>
        </form>
      </div>
    </div>
  </c-modal>
  <!-- show product details popup end -->
</div>

<ng-template #showEmptyView>
  <tr *ngIf="!loading">No Product found..</tr>
</ng-template>
